module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/en_4-707cf1290f1706e542f0b93ea7fa8b77.jpg";